/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CityDto } from '../models/city-dto';
import { cityGet } from '../fn/city/city-get';
import { CityGet$Params } from '../fn/city/city-get';

@Injectable({ providedIn: 'root' })
export class CityService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `cityGet()` */
  static readonly CityGetPath = '/v1/City/Get';

  /**
   * Search cities,   Permissions [AuthenticatedUser|LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME|INSURER].
   *
   * It will return all matching cities on yours filter criteria
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cityGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  cityGet$Response(params?: CityGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CityDto>>> {
    return cityGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Search cities,   Permissions [AuthenticatedUser|LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME|INSURER].
   *
   * It will return all matching cities on yours filter criteria
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cityGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cityGet(params?: CityGet$Params, context?: HttpContext): Observable<Array<CityDto>> {
    return this.cityGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CityDto>>): Array<CityDto> => r.body)
    );
  }

}
